
const Hizmet = resolve => {
    require.ensure(['../views/apps/hizmet/Hizmet'], () => {
        resolve(require('../views/apps/hizmet/Hizmet'))
    })
};
const HizmetDetay = resolve => {
    require.ensure(['../views/apps/hizmet/HizmetDetay'], () => {
        resolve(require('../views/apps/hizmet/HizmetDetay'))
    })
};
const HizmetTanimla = resolve => {
    require.ensure(['../views/apps/hizmet/HizmetTanimla'], () => {
        resolve(require('../views/apps/hizmet/HizmetTanimla'))
    })
};
const HizmetlerListe = resolve => {
    require.ensure(['../views/apps/hizmet/HizmetlerListe'], () => {
        resolve(require('../views/apps/hizmet/HizmetlerListe'))
    })
};
const HizmetDuzenle = resolve => {
    require.ensure(['../views/apps/hizmet/HizmetDuzenle'], () => {
        resolve(require('../views/apps/hizmet/HizmetDuzenle'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/hizmet/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/hizmet/kategori/KategoriTanimlama'))
    })
};

import Vue from 'vue'

Vue.component('HizmetDetay', HizmetDetay);
Vue.component('HizmetTanimla', HizmetTanimla);
Vue.component('HizmetListesi', HizmetlerListe);
Vue.component('HizmetDuzenle', HizmetDuzenle);
Vue.component('HizmetKategorileri', KategoriTanimlama);
import layouts from '../layout'

export default {
    path: '/hizmet',
    name: 'hizmet',
    component: Hizmet,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'hizmetdetay',
            component: HizmetDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
